import { fetchBlogPost } from './blog';

import { resolveBlogArticleAccess } from '../lib/article-locale';
import type { BlogArticleAccess } from '../lib/article-locale';

export const loadBlogArticleAccess = async (
  categorySlug: string,
  id: number,
  lang: string
): Promise<BlogArticleAccess> => {
  const post = await fetchBlogPost(categorySlug, id, lang);
  const fallbackLang = lang === 'en' ? 'ru' : 'en';
  const fallbackPost = post
    ? null
    : await fetchBlogPost(categorySlug, id, fallbackLang);

  return resolveBlogArticleAccess({
    requestedLang: lang,
    post,
    fallbackPost,
  });
};
